var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14C5.13401 14 2 10.866 2 7C2 3.13401 5.13401 0 9 0C12.866 0 16 3.13401 16 7C16 10.866 12.866 14 9 14ZM14 6.5C14 4.20056 11.8996 2 9.5 2C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3C11.3366 3 13 4.7427 13 6.5C13 6.77614 13.2239 7 13.5 7C13.7761 7 14 6.77614 14 6.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9597 17.3032C18.1011 17.6331 17.8591 18.0001 17.5001 18.0001H14.7072L12.8537 19.8537C12.6123 20.095 12.2055 20.029 12.0529 19.7237L9.70376 15.3448C12.1177 15.1426 14.2269 13.8685 15.5539 12L17.9597 17.3032Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94775 19.7237C5.79513 20.029 5.38831 20.095 5.14699 19.8537L3.29343 18.0001H0.500539C0.141581 18.0001 -0.100434 17.6331 0.040966 17.3032L2.50025 12.0006C3.82734 13.8689 5.93658 15.1428 8.35056 15.3449L5.94775 19.7237Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualification);
export default __webpack_public_path__ + "static/media/qualification.1153f0f586193af6cbccc1c1a4e095ab.svg";
export { ForwardRef as ReactComponent };